import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React from 'react';

import { getIsAdmin, getIsLoggedIn } from '../redux/selectors';

function PrivateRoute({
    component: Component,
    isAdminRoute,
    location,
    ...rest
}) {
    const isAdmin = useSelector(getIsAdmin);
    const isLoggedIn = useSelector(getIsLoggedIn);

    if (isAdminRoute) {
        return isAdmin ? (
            <Route {...rest} component={Component} />
        ) : (
            <Redirect to="/" />
        );
    }

    return isLoggedIn ? (
        <Route {...rest} component={Component} />
    ) : (
        <Redirect
            to={{
                pathname: '/login',
                state: { from: location },
            }}
        />
    );
}

export default PrivateRoute;
